import * as commonItems from './commonItems'
import router from '@/router'

export const namespaced = true

export const state = {
  itemsCount: 0,
  items: [],
  page: 1,
  pageStatus: ''
}

export const mutations = {
  ...commonItems.mutations
}

export const actions = {
  ...commonItems.actions
}
